import React from 'react'

const Cardplato = (props) => {
  return (
    <div className="card">
      <div className="DivImg">
        <img className="pequeña" src={props.imagen} alt="" />
      </div>
      <div className="Div2">
        <div className="texto">
          <div className="Titulo">
            {props.nombre}
          </div>
          <div className="Descripción">
            {props.descripcion}
          </div>
        </div>

        <div className="PreciosGen">
          <div className="Precios">
            Restaurante <br></br>${props.precioR.toLocaleString('en-GB')}
          </div>
          <div className="Precios">
            Para llevar <br></br>${props.precioL.toLocaleString('en-GB')}
          </div>
          <div className="Precios">
            Domicilio <br></br>${props.precioD.toLocaleString('en-GB')}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cardplato
